var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ejs-dropdownlist',{attrs:{"fields":_vm.fields,"dataSource":_vm.data.datasource,"placeholder":_vm.data.placeholder,"allowCustom":_vm.allowCustom,"enabled":_vm.data.enabled,"name":_vm.data.name},model:{value:(_vm.data.value),callback:function ($$v) {_vm.$set(_vm.data, "value", $$v)},expression:"data.value"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }